import { FaInstagram, FaYoutube, FaSpotify } from "react-icons/fa";

function SocialMedia({ showPage, blackBackground = false }) {
  return (
    <>
      <div
        className={`fixed bottom-4 right-4 flex space-x-4 z-[1000] ${
          blackBackground && "pr-5 pb-1"
        }`}
      >
        <a
          href="https://www.instagram.com/livethewill"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className={`text-3xl transition-colors duration-300 ${
            showPage && !blackBackground
              ? "text-black hover:text-gray-700"
              : "text-white hover:text-gray-400"
          }`} // Change color based on background
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.youtube.com/@livethewill7257"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
          className={`text-3xl transition-colors duration-300 ${
            showPage && !blackBackground
              ? "text-black hover:text-gray-700"
              : "text-white hover:text-gray-400"
          }`}
        >
          <FaYoutube />
        </a>
        <a
          href="https://open.spotify.com/artist/6qhgCvncGnVgbBH16Oxg6c"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Spotify"
          className={`text-3xl transition-colors duration-300 ${
            showPage && !blackBackground
              ? "text-black hover:text-gray-700"
              : "text-white hover:text-gray-400"
          }`}
        >
          <FaSpotify />
        </a>
      </div>
    </>
  );
}

export default SocialMedia;
